import FormConfig from "../formConfig.js";
import { fun_PostAction } from "@/api/index";
import { Loading } from "element-ui";
export default {
  data() {
    return {
      // 全局加载
      fullLoading: false,
      // 列表loading状态
      loading: false,
      // 表单对象
      form: {
        id: null, // 主键
        processClass: null, // 流程种类
        processType: null, // 流程类型
        competentDepart: null, // 管理部门
        processDistinguish: null, // 流程区分
        operatorGuide: null, // 操作指南
        description: null, // 备注
      },
      // 表单错误
      errRules: {
        processClass: null, // 流程种类
        processType: null, // 流程类型
        competentDepart: null, // 管理部门
        processDistinguish: null, // 流程区分
        operatorGuide: null, // 操作指南
        description: null, // 备注
      },
      // 表单配置
      formConfigList: FormConfig.configList(),
      controllerFlg: this.$route.query.type,// 操作标志
      id: this.$route.query.id,  // 主键
      /*****************************监管流程节点****************************/
      nodeLoading: false, // 列表loading状态
      // 表头按钮组
      nodeBtnList: [
        {
          name: "添加",
          type: "success",
          icon: "document-add"
        }, 
        {
          name: "删除",
          type: "danger",
          icon: "delete"
        },
      ],
      // 查询表单字段
      nodeForm: {

      },
      // 错误消息
      nodeRules: {
        nodeName: [
          {
            required: true,
            message: "请输入节点名称",
            trigger: "blur"
          }
        ],
        nodeNo: [
          {
            required: true,
            message: "请输入节点序号",
            trigger: "blur"
          }
        ],
        delegateAction: [
          {
            required: true,
            message: "请输入委托动作",
            trigger: "blur"
          }
        ],
      },
      // 表单
      nodeFormObj: {
        // 表格数据
        nodeTableData: [],
      },
      // 勾选的数据
      nodeMultipleSelection: [],
      key: "", // 被删除的主键
    };
  },
  // 注册组件
  components: {

  },
  // 模板编译完成
  mounted() {
    // 打开loading
    this.loading = true;
    // 如果是详情
    if (this.controllerFlg == "details") {
      // 获取详情信息
      this.fun_Details();
      // 遍历表单
      this.formConfigList.map(e => {
        // 遍历
        e.formConfigList.map(form => {
          // 不可编辑
          form.disabled = true;
        });
      });
      // 清空表头
      this.nodeBtnList = [];
    } 
    // 修改
    else if (this.controllerFlg == "update") {
      // 获取详情信息
      this.fun_Details();
    }  
  },
  // 自定义方法
  methods: {
    /**
     * @description 详情
     * @author
     */
    fun_Details() {
      // 请求，获取结果集
      fun_PostAction("/spProcess/detail", {
        id: this.id, // 主键
      }).then(res => {
        // 解构res.data
        const { result, data } = res.data;
        // 判断请求是否成功
        if (result) {
          // 数据回显
          this.form = data.model;
          // 回显table
          this.nodeFormObj.nodeTableData = data.nodeList;
          // 关闭loading
          this.loading = false;
        }
      });
    },
    /**
     * 表头按钮事件
     * @params e 按钮name
     * @author 付翔
     */
    fun_NodeClick(e) {
      switch (e) {
        case "添加":
          // 调用添加方法
          this.fun_NodeAdd();
          break;
        default:
          // 调用删除方法
          this.fun_NodeDel();
      }
    },
    /**
     * 勾选事件
     * @params e 选中的数据
     */
    fun_NodeHandleSelectionChange(e) {
      // 将勾选的value值赋给multipleSelection数组
      this.nodeMultipleSelection = e;
    },
    /**
     * 列表添加class
     */
    addClass(row, column, rowIndex, columnIndex) {
      // 判断是序号
      if (row.column.type === "index") {
        return "index"
      }
    },
    /**
     * 添加时执行的方法
     * @author shuhua
     */
    tableRowClassName(row, rowIndex) {
      // 给每一行新增一个下标
      row.row.index = row.rowIndex;
    },
    /**
     * 委托动作
     * @author shuhua
     */
    fun_ChangeDelegateAction(e, i) {
      // 赋值
      this.nodeFormObj.nodeTableData[i].delegateAction = e;
    },
    /**
    * 添加监管流程节点
    */
    fun_NodeAdd() {
      // 调用添加方法
      let newValue = {
        nodeName: null,
        nodeNo: null,
        delegateAction: null,
      };
      //添加新的行数
      this.nodeFormObj.nodeTableData.push(newValue);
    },
    /**
     * 删除监管流程节点
     */
    fun_NodeDel() {
      // 判断是否勾选
      if (this.nodeMultipleSelection.length == 0) {
        // 提示信息
        this.$alert("最少选择一条数据！", "warning");
        return;
      }
      // 判断是否勾选
      else if (this.nodeMultipleSelection.length > 1) {
        // 提示信息
        this.$alert("只能选择一条数据！", "warning");
        return;
      }
      // 主键不为空
      if (this.nodeMultipleSelection[0].id != null && this.nodeMultipleSelection[0].id != ""){
        // 请求，获取结果集
        fun_PostAction("/spProcess/checkProcessNode", {
          key: this.nodeMultipleSelection[0].id, // 主键
        }).then(res => {
          // 解构res.data
          const {
            result   
          } = res.data;
          // 判断请求是否成功
          if (result) {
            // 删除提交
            this.fun_NodeDelSubmit();
          }else{
            // 请求失败，弹出失败msg的消息提示
            this.$message.error("该监管流程节点已经被使用， 不能删除！");
            return false;
          }
        });
      }else{
        // 删除提交
        this.fun_NodeDelSubmit();
      }
    },
    /**
      * 删除监管流程节点
      */
    fun_NodeDelSubmit() {
      // 弹出询问confirm
      this.$confirm("是否确定删除选中数据?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        // 遍历
        this.nodeMultipleSelection.map((value, index) => {
          // 遍历
          this.nodeFormObj.nodeTableData.map((v, i) => {
            // 匹配已选中的
            if (value.index === v.index) {
              // 主键不为空
              if (this.nodeFormObj.nodeTableData[index].id != null && this.nodeFormObj.nodeTableData[index].id != ""){
                // 拼接
                this.key += this.nodeFormObj.nodeTableData[index].id + ",";
              }
              // 删除勾选的数据
              this.nodeFormObj.nodeTableData.splice(i, 1);
            }
          });
        });
        // 清除选中数据
        this.$refs.multipleTable.clearSelection();
      });
    },
    /**
     * 下拉框值改变事件
     * @author shuhua
     */
    fun_GetSelectVal(e, i) {
      // 赋值
      this.form[i] = e;
    },
    /**
     * 单选改变事件
     * @author shuhua
     */
    fun_GetRadioVal(e, i) {
      // 赋值
      this.form[i] = e;
      // 如果是流程种类
      if (i == "processClass") {
        // 清空流程类型
        this.form.processType = "";
        // 清空管理部门
        this.form.competentDepart = "";
        // 如果选择监管流程
        if(e == "0"){
          // 遍历表单
          this.formConfigList[0].formConfigList.map(e => {
            // 如果是流程类型
            if (e.value == "processType") {
              // 查询路径
              e.queryParams = {
                url: "/dataDictionaryEntries/DictionaryCombobox",
                zdid: "201510311952300005",
              };
            }
            // 如果是管理部门
            if (e.value == "competentDepart") {
              // 查询路径
              e.queryParams = {
                url: "/zoneDepartment/DepartmentCombobox",
              };
            }
          });
        }
        // 如果选择工作人员流程
        else{
          // 遍历表单
          this.formConfigList[0].formConfigList.map(e => {
            // 如果是流程类型
            if (e.value == "processType") {
              // 查询路径
              e.queryParams = {
                url: "/dataDictionaryEntries/DictionaryCombobox",
                zdid: "202405071421595161",
              };
            }
            // 如果是管理部门
            if (e.value == "competentDepart") {
              // 查询路径
              e.queryParams = {
                url: "/zoneDepartment/CenterCombobox",
              };
            }
          });
        }
      }
    },
    /**
     * 保存修改
     * @param e
     */
    fun_InsUpd() {
      // 表单验证
      this.$refs.collapseForm.$refs.enInform.validate(valid => {
        // 验证通过
        if (valid) {
          // 如果监管流程节点为空
          if (this.nodeFormObj.nodeTableData.length == 0){
            // 请求失败，弹出失败msg的消息提示
            this.$message.error("监管流程节点不能为空！");
            return false;
          }
          // 遍历
          for (const index in this.nodeFormObj.nodeTableData) {
            // 节点序号相同数量
            let nodeNoNum = 0
            // 节点序号
            let nodeNo = this.nodeFormObj.nodeTableData[index].nodeNo;
            // 遍历
            for (const num in this.nodeFormObj.nodeTableData) {
              // 如果节点序号相同
              if (nodeNo == this.nodeFormObj.nodeTableData[num].nodeNo){
                nodeNoNum++;
              }
            }
            // 如果节点序号相同数量大于1
            if (nodeNoNum > 1) {
              // 请求失败，弹出失败msg的消息提示
              this.$message.error("节点序号" + nodeNo + "有重复，请修改后再保存！");
              return false;
            }
          }
          // 请求，获取结果集
          fun_PostAction("/spProcess/checkProcessName", {
            id: this.form.id, // 主键
            processType: this.form.processType, // 流程类型
            competentDepart: this.form.competentDepart, // 区管代码
          }).then(res => {
            // 解构res.data
            const {
              result
            } = res.data;
            // 判断请求是否成功
            if (result) {
               // 提交的方法
               this.fun_Submit();
            } else {
               // 请求失败，弹出失败msg的消息提示
               this.$message.error("流程类型已存在，请重新填写！");
               return false;
            }
          });
        } else {
          return false;
        }
      });
    },
    /**
     * 提交
     * @author shuhua
     */
    fun_Submit() {
      // 弹出询问confirm
      this.$confirm("确定进行提交操作吗？提交后将不能修改信息，请谨慎操作！", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        try {
          // 请求
          fun_PostAction("/spProcess/saveOrUpdate", {
            ...this.form, // form表单数据
            key: this.key,
            nodeList: JSON.stringify(this.nodeFormObj.nodeTableData), // 项目信息
            controllerFlg: this.controllerFlg // 操作标志
          }).then(res => {
            // 解构res.data
            const {
              result,
              data,
              msg
            } = res.data;
            // 解析后台返回的结果集，判断是否成功
            if (result) {
              // 操作成功
              this.$message.success(msg);
              // 返回一览
              this.fun_Back();
            } else {
              // 如果页面验证失败
              if (data != null && data != "") {
                // 返回错误消息
                this.errRules = data;
                // 请求失败，弹出失败msg的消息提示
                this.$message.error("您输入的数据存在错误！");
              } else {
                // 请求失败，弹出失败msg的消息提示
                this.$message.error(msg);
              }
            }
            // 关闭loading
            this.loading = false;
          });
        } catch (e) {
          // 请求失败，弹出失败msg的消息提示
          this.$message.error("操作失败！" + e);
          // 关闭loading
          this.loading = false;
        }
      });
      
    },
    /**
     * 返回的方法
     * @author shuhua
     */
    fun_Back() {
      // 返回
      this.$router.back();
    },
  }
};
